export default {
    LoadBrandsSubscriptions: {
        name: 'LoadBrandsSubscriptions',
    },
};
